export default class Validation {
  constructor() {
    this.forms = [];
  }
  
  add(selector) {
    this.enableValidationOn(selector);
    this.refresh();
    this.initBootstrapValidation();
  }
  
  enableValidationOn(selector) {
    const forms = document.querySelectorAll(selector);
    
    forms.forEach(form => {
      form.setAttribute('novalidate', '');
      form.classList.add('needs-validation');
    });
  }
  
  refresh() {
    this.forms = document.querySelectorAll('.needs-validation');
  }
  
  initBootstrapValidation() {
    this.forms.forEach(form => {
      if (form.__validationBound) return;
      
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          // Update custom messages for each invalid field
          this.updateValidationMessages(form);
          
        }
        form.classList.add('was-validated');
      }, true);
      
      // Add real-time validation
      this.addRealtimeValidation(form);
      
      form.__validationBound = true;
    });
  }
  
  addRealtimeValidation(form) {
    const inputs = form.querySelectorAll('input, textarea, select');
    
    inputs.forEach(input => {
      input.addEventListener('blur', () => {
        this.updateValidationMessages(input);
      });
      
      input.addEventListener('input', () => {
        if (input.classList.contains('is-invalid') || input.classList.contains('is-valid')) {
          this.updateValidationMessages(input);
        }
      });
    });
  }
  
  updateValidationMessages(formOrInput) {
    // Handle both single input and entire form
    const inputs = formOrInput.tagName === 'FORM' 
    ? formOrInput.querySelectorAll('input, select, textarea')
    : [formOrInput];
    
    
    inputs.forEach(input => {
      const feedback = input.parentElement.querySelector('.invalid-feedback');
      if (!feedback) return;
      
      console.log('Validating:', input.name, 'Value:', input.value, 'Valid:', input.checkValidity());
      console.log('Validity object:', input.validity);
      
      // Extract field name
      const fieldName = input.name
      .replace(/formfields\[|\]/g, '')
      .replace(/_/g, ' ');
      
      // Add/remove validation classes for real-time feedback
      if (input.checkValidity()) {
        input.classList.remove('is-invalid');
        input.classList.add('is-valid');
      } else {
        input.classList.remove('is-valid');
        input.classList.add('is-invalid');
        
        // Update error message
        if (input.validity.valueMissing) {
          if (input.tagName === 'SELECT') {
            feedback.textContent = `Please select a ${fieldName}.`;
          } else {
            feedback.textContent = `Please enter your ${fieldName}.`;
          }
        } else if (input.validity.tooShort) {
          feedback.textContent = `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be at least ${input.minLength} characters.`;
        } else if (input.validity.tooLong) {
          feedback.textContent = `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be no more than ${input.maxLength} characters.`;
        } else if (input.validity.typeMismatch || input.validity.patternMismatch) {
          if (input.type === 'email') {
            feedback.textContent = 'Please enter a valid email address (e.g., rocket@example.com).';
          } else if (input.type === 'tel') {
            feedback.textContent = 'Please enter a valid phone number (e.g., 123-456-7890).';
          } else {
            feedback.textContent = `Please enter a valid ${fieldName}.`;
          }
        } else {
          console.log('UNKNOWN VALIDATION ERROR:', input.name, 'validity:', input.validity);
        }
      }
    });
  }
}

// call for your specific form
const validation = new Validation();
validation.add('#contact-form form');
validation.add('#get-started-form form');
validation.add('#iot-form form');
validation.add('#iot-platform-cta form');
validation.add('#metaverse-form form');
validation.add('#metaverse-cta form');
validation.add('.request-demo-form form');
validation.add('#lp-form form');
validation.add('#join-list form');
validation.add('.careers-form form');
validation.add('.resources-right-form form');